import { generateDefaultActions, defaultReturn, makePayload, requestSaga } from "shared-utility/store/utils/helpers";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import { call, put, takeLatest } from "redux-saga/effects";
import { authorizedRequest } from "utils/api";

export const GET_SOURCE_FILE_TYPES = generateDefaultActions("GET_SOURCE_FILE_TYPES");
export const getSourceFileTypes = payload => makePayload(GET_SOURCE_FILE_TYPES.value, payload);
function* getSourceFileTypesSaga() {
  const url = "/source-files/types";
  yield requestSaga(GET_SOURCE_FILE_TYPES, url, "GET", null, null, null, true);
}

export const GET_VENDOR_INTEGRATIONS_FOR_COMPANY = generateDefaultActions("GET_VENDOR_INTEGRATIONS_FOR_COMPANY");
export const getVendorIntegrationsForCompany = payload => makePayload(GET_VENDOR_INTEGRATIONS_FOR_COMPANY.value, payload);
function* getVendorIntegrationsForCompanySaga({ companyId }) {
  const url = `/source-files/vendor-integrations/${companyId}`;
  yield requestSaga(GET_VENDOR_INTEGRATIONS_FOR_COMPANY, url, "GET", null, null, null, true);
}

export const ENABLE_VENDOR_INTEGRATION = generateDefaultActions("ENABLE_VENDOR_INTEGRATION");
export const enableVendorIntegration = payload => makePayload(ENABLE_VENDOR_INTEGRATION.value, payload);
function* enableVendorIntegrationSaga({ data }) {
  const url = "/source-files/vendor-integrations";
  yield requestSaga(ENABLE_VENDOR_INTEGRATION, url, "POST", data, null, null, true);
}

export const DISABLE_VENDOR_INTEGRATION = generateDefaultActions("DISABLE_VENDOR_INTEGRATION");
export const disableVendorIntegration = payload => makePayload(DISABLE_VENDOR_INTEGRATION.value, payload);
function* disableVendorIntegrationSaga({ integrationId }) {
  const url = `/source-files/vendor-integrations/${integrationId}`;
  yield requestSaga(DISABLE_VENDOR_INTEGRATION, url, "DELETE", null, null, null, true);
}

export const GET_VENDOR_PROPERTIES_IDS = generateDefaultActions("GET_VENDOR_PROPERTIES_IDS");
export const getVendorPropertiesIds = payload => makePayload(GET_VENDOR_PROPERTIES_IDS.value, payload);
function* getVendorPropertiesIdsSaga({ dealId, companyId }) {
  const url = `/source-files/vendor-property-mappings/${companyId}/${dealId}`;
  yield requestSaga(GET_VENDOR_PROPERTIES_IDS, url, "GET", null, null, null, true);
}

export const UPDATE_VENDOR_PROPERTY_IDS = generateDefaultActions("UPDATE_VENDOR_PROPERTY_IDS");
export const updateVendorPropertyIds = payload => makePayload(UPDATE_VENDOR_PROPERTY_IDS.value, payload);
function* updateVendorPropertyIdsSaga({ data }) {
  const url = "/source-files/vendor-property-mappings";
  yield requestSaga(UPDATE_VENDOR_PROPERTY_IDS, url, "POST", data, null, null, true);
}

export const GET_LENDER_REPORTING_ACTIVE_FOR_COMPANY = generateDefaultActions("GET_LENDER_REPORTING_ACTIVE_FOR_COMPANY");
export const getLenderReportingActiveForCompany = payload => makePayload(GET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.value, payload);
function* getLenderReportingActiveForCompanySaga({ companyId }) {
  const url = `/companyReadyForLenderReporting/${companyId}`;
  const response = yield call(authorizedRequest, url, "GET");
  yield put({ type: GET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.success, payload: response });
}

export const SET_LENDER_REPORTING_ACTIVE_FOR_COMPANY = generateDefaultActions("SET_LENDER_REPORTING_ACTIVE_FOR_COMPANY");
export const setLenderReportingActiveForCompany = payload => makePayload(SET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.value, payload);
function* setLenderReportingActiveForCompanySaga({ companyId, isReady }) {
  const url = `/companyReadyForLenderReporting/${companyId}`;
  const response = yield call(authorizedRequest, url, "POST", { isReady });
  yield put({ type: SET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.success, payload: response });
}

export const DEALS_BY_COMPANY_ID = generateDefaultActions("DEALS_BY_COMPANY_ID");
export const getDealsByCompanyId = payload => makePayload(DEALS_BY_COMPANY_ID.value, payload);
function* getDealsByCompanyIdSaga({ companyId }) {
  const url = `/deals/companyId=${companyId}`;
  yield requestSaga(DEALS_BY_COMPANY_ID, url, "GET");
}

export const DEAL_UPDATE_LENDER_REPORTING = generateDefaultActions("DEAL_UPDATE_LENDER_REPORTING");
export const updateDealsForLenderReporting = payload => makePayload(DEAL_UPDATE_LENDER_REPORTING.value, { payload });
function* updateDealsForLenderReportingSaga(payload) {
  yield requestSaga(DEAL_UPDATE_LENDER_REPORTING, `/updateDealsForLenderReporting/${payload.payload.id}`, "PUT");
}

export const DELETE_OVERDUE_RGIS_BY_DATE = generateDefaultActions("DELETE_OVERDUE_RGIS_BY_DATE");
export const deleteOverdueRgisByDate = payload => makePayload(DELETE_OVERDUE_RGIS_BY_DATE.value, payload);
function* deleteOverdueRgisByDateSaga({ date, companyId }) {
  const url = `/report-groups/instances/deleteOverdue/${companyId}/${date}`;
  yield requestSaga(DELETE_OVERDUE_RGIS_BY_DATE, url, "DELETE", null, null, null, true);
}

export const RECOVER_OVERDUE_RGIS_BY_DATE = generateDefaultActions("RECOVER_OVERDUE_RGIS_BY_DATE");
export const recoverOverdueRgisByDate = payload => makePayload(RECOVER_OVERDUE_RGIS_BY_DATE.value, payload);
function* recoverOverdueRgisByDateSaga({ date, companyId }) {
  const url = `/report-groups/instances/recoverOverdue/${companyId}/${date}`;
  yield requestSaga(RECOVER_OVERDUE_RGIS_BY_DATE, url, "PUT", null, null, null, true);
}

export const GET_RENTROLL_SETTINGS = generateDefaultActions("GET_RENTROLL_SETTINGS");
export const getRentRollSettings = payload => makePayload(GET_RENTROLL_SETTINGS.value, payload);
const getRentRollSettingsSaga = function* () {
  const url = `/lrd/rent-rolls/chargeCodesAliases/vendor/30c31266-8ca0-4a86-ba7e-e0242b37f5e6`;
  const result = yield requestSaga(GET_RENTROLL_SETTINGS, url, "GET", null, null, null, false);
  if (result.error) {
    ToastError("Failed to load rent roll settings.");
  }
};

export const ADD_RENT_CODE_ALIAS = generateDefaultActions("ADD_RENT_CODE_ALIAS");
export const addRentCodeAlias = payload => makePayload(ADD_RENT_CODE_ALIAS.value, payload);
const addRentCodeAliasSaga = function* ({ codeAlias }) {
  const url = `/lrd/rent-rolls/chargeCodesAliases`;
  try {
    const response = yield call(authorizedRequest, url, "POST", { alias: codeAlias.alias });
    yield put(ADD_RENT_CODE_ALIAS.createSuccess({ response, previusCodeAliasId: codeAlias.id }));
    ToastSuccess("The Rent Code has been successfully added.");
  } catch (error) {
    yield put(ADD_RENT_CODE_ALIAS.createFailure({ error, previusCodeAliasId: codeAlias.id }));
    ToastError("Failed to add the Rent Code.");
  }
};

export const UPDATE_RENT_CODE_ALIAS = generateDefaultActions("UPDATE_RENT_CODE_ALIAS");
export const updateRentCodeAlias = payload => makePayload(UPDATE_RENT_CODE_ALIAS.value, payload);
const updateRentCodeAliasSaga = function* ({ codeAliasId, codeAliasValue }) {
  const url = `/lrd/rent-rolls/chargeCodesAliases`;
  const result = yield requestSaga(UPDATE_RENT_CODE_ALIAS, url, "PUT", { id: codeAliasId, alias: codeAliasValue });
  if (!result.error) {
    ToastSuccess("The Rent Code has been successfully updated.");
  }
};

export const DELETE_RENT_CODE_ALIAS = generateDefaultActions("DELETE_RENT_CODE_ALIAS");
export const deleteRentCodeAlias = payload => makePayload(DELETE_RENT_CODE_ALIAS.value, payload);
const deleteRentCodeAliasSaga = function* ({ codeAliasId }) {
  const url = `/lrd/rent-rolls/chargeCodesAliases/${codeAliasId}`;
  const result = yield requestSaga(DELETE_RENT_CODE_ALIAS, url, "DELETE", codeAliasId);
  if (!result.error) {
    ToastSuccess("The Rent Code has been successfully deleted.");
  }
};

export const actionCreators = {
  getSourceFileTypes,
  getVendorIntegrationsForCompany,
  enableVendorIntegration,
  disableVendorIntegration,
  getVendorPropertiesIds,
  updateVendorPropertyIds,
  getLenderReportingActiveForCompany,
  setLenderReportingActiveForCompany,
  getDealsByCompanyId,
  updateDealsForLenderReporting,
  deleteOverdueRgisByDate,
  recoverOverdueRgisByDate,
  getRentRollSettings,
  addRentCodeAlias,
  updateRentCodeAlias,
  deleteRentCodeAlias
};

const initialState = {
  sourceFileTypes: null,
  companyIntegrations: null,
  isIntegrationsLoading: false,
  vendorProperiesForDeal: null,
  isCompanyReadyForLenderReporting: null,
  isLenderReportingLoading: false,
  isDeletingOverdueRgis: false,
  isRetrievingOverdueRgis: false,
  rentRollSettings: null
};

export const vendorIntegrationsReducer = function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SOURCE_FILE_TYPES.failure:
      return defaultReturn({ ...state, isIntegrationsLoading: false }, null, "sourceFileTypes");
    case GET_SOURCE_FILE_TYPES.success:
      return defaultReturn({ ...state, isIntegrationsLoading: false }, payload.data, "sourceFileTypes");
    case GET_SOURCE_FILE_TYPES.value:
      return defaultReturn({ ...state, isIntegrationsLoading: true });

    case GET_VENDOR_INTEGRATIONS_FOR_COMPANY.failure:
      return defaultReturn({ ...state, isIntegrationsLoading: false }, null, "companyIntegrations");
    case GET_VENDOR_INTEGRATIONS_FOR_COMPANY.success:
      return defaultReturn({ ...state, isIntegrationsLoading: false }, payload.data, "companyIntegrations");
    case GET_VENDOR_INTEGRATIONS_FOR_COMPANY.value:
      return defaultReturn({ ...state, isIntegrationsLoading: true });

    case ENABLE_VENDOR_INTEGRATION.failure:
      ToastError("Failed to enable integration.");

      return defaultReturn(state);
    case ENABLE_VENDOR_INTEGRATION.success:
      return defaultReturn({ ...state }, [...state.companyIntegrations, payload.data], "companyIntegrations");

    case DISABLE_VENDOR_INTEGRATION.failure:
      ToastError("Failed to disable integration.");

      return defaultReturn({ ...state, isIntegrationsLoading: false });
    case DISABLE_VENDOR_INTEGRATION.success:
      return defaultReturn(
        { ...state },
        state.companyIntegrations.filter(integr => integr.id !== payload.data.deletedId),
        "companyIntegrations"
      );

    case GET_VENDOR_PROPERTIES_IDS.failure:
      ToastError("Failed to fetch vendor property IDs.");

      return defaultReturn({ ...state }, null, "vendorProperiesForDeal");
    case GET_VENDOR_PROPERTIES_IDS.success:
      return defaultReturn({ ...state }, payload.data, "vendorProperiesForDeal");
    case GET_VENDOR_PROPERTIES_IDS.value:
      return defaultReturn({ ...state });

    case UPDATE_VENDOR_PROPERTY_IDS.failure:
      ToastError("Failed to update vendor properties IDs.");

      return defaultReturn({ ...state });
    case UPDATE_VENDOR_PROPERTY_IDS.success:
      ToastSuccess("Vendor property IDs have been updated successfully.");

      return defaultReturn({ ...state }, payload.data, "vendorProperiesForDeal");
    case UPDATE_VENDOR_PROPERTY_IDS.value:
      return defaultReturn({ ...state });

    case GET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.failure:
      ToastError("Failed to fetch lender reporting status.");
      return defaultReturn({ ...state, isLenderReportingLoading: false }, false, "isCompanyReadyForLenderReporting");

    case GET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.success:
      return defaultReturn({ ...state, isLenderReportingLoading: false }, payload.isReady, "isCompanyReadyForLenderReporting");

    case GET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.value:
      return defaultReturn({ ...state, isLenderReportingLoading: true });

    case SET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.failure:
      ToastError("Failed to set lender reporting status.");
      return defaultReturn({ ...state }, false, "isCompanyReadyForLenderReporting");

    case SET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.success:
      return defaultReturn({ ...state }, payload.isReady, "isCompanyReadyForLenderReporting");

    case DEALS_BY_COMPANY_ID.success:
      return defaultReturn(state, payload.deals, "dealsByCompanyId");

    case DELETE_OVERDUE_RGIS_BY_DATE.value:
      return defaultReturn({ ...state, isDeletingOverdueRgis: true });

    case DELETE_OVERDUE_RGIS_BY_DATE.success:
      ToastSuccess(payload.message);
      return defaultReturn({ ...state, isDeletingOverdueRgis: false });

    case DELETE_OVERDUE_RGIS_BY_DATE.failure:
      ToastError("Failed to delete overdue RGIs.");
      return defaultReturn({ ...state, isDeletingOverdueRgis: false });

    case RECOVER_OVERDUE_RGIS_BY_DATE.value:
      return defaultReturn({ ...state, isRetrievingOverdueRgis: true });

    case RECOVER_OVERDUE_RGIS_BY_DATE.success:
      ToastSuccess(payload.message);
      return defaultReturn({ ...state, isRetrievingOverdueRgis: false });

    case RECOVER_OVERDUE_RGIS_BY_DATE.failure:
      ToastError("Failed to recover overdue RGIs.");
      return defaultReturn({ ...state, isRetrievingOverdueRgis: false });

    case DEAL_UPDATE_LENDER_REPORTING.success:
      return state;

    case GET_RENTROLL_SETTINGS.success: {
      const rentCodeAliases = [];
      const otherChargeCodeAliases = [];

      payload.forEach((codeAlias) => {
        const container = codeAlias.chargeCode === "Rent"
          ? rentCodeAliases
          : otherChargeCodeAliases;

        container.push(codeAlias);
      });

      const rentRollSettings = {
        vendorId: payload.vendorId,
        rentCodeAliases,
        otherChargeCodeAliases
      };

      return defaultReturn(state, rentRollSettings, "rentRollSettings");
    }

    case GET_RENTROLL_SETTINGS.failure: {
      const rentRollSettings = {
        rentCodeAliases: [],
        otherChargeCodeAliases: []
      };

      return defaultReturn(state, rentRollSettings, "rentRollSettings");
    }

    case ADD_RENT_CODE_ALIAS.value: {
      const newRentRollSettings = {...state.rentRollSettings};
      newRentRollSettings.rentCodeAliases.push(action.codeAlias);
      return defaultReturn(state, newRentRollSettings, "rentRollSettings");
    }

    case ADD_RENT_CODE_ALIAS.success: {
      const newRentRollSettings = {...state.rentRollSettings};
      const index = newRentRollSettings.rentCodeAliases.findIndex(code => code.id === payload.previusCodeAliasId);
      newRentRollSettings.rentCodeAliases.splice(index, 1, payload.response);
      return defaultReturn(state, newRentRollSettings, "rentRollSettings");
    }

    case ADD_RENT_CODE_ALIAS.failure: {
      const newRentRollSettings = {...state.rentRollSettings};
      const index = newRentRollSettings.rentCodeAliases.findIndex(code => code.id === payload.previusCodeAliasId);
      newRentRollSettings.rentCodeAliases.splice(index, 1);
      return defaultReturn(state, newRentRollSettings, "rentRollSettings");
    }

    case UPDATE_RENT_CODE_ALIAS.value: {
      const newRentRollSettings = {...state.rentRollSettings};
      newRentRollSettings.rentCodeAliases[action.index].alias = action.codeAliasValue;
      return defaultReturn(state, newRentRollSettings, "rentRollSettings");
    }

    case DELETE_RENT_CODE_ALIAS.value: {
      const newRentRollSettings = {...state.rentRollSettings};
      newRentRollSettings.rentCodeAliases.splice(action.index, 1);
      return defaultReturn(state, newRentRollSettings, "rentRollSettings");
    }

    default:
      return state;
  }
};

export const vendorIntegrationsSaga = function* () {
  yield takeLatest(GET_SOURCE_FILE_TYPES.value, getSourceFileTypesSaga);
  yield takeLatest(GET_VENDOR_INTEGRATIONS_FOR_COMPANY.value, getVendorIntegrationsForCompanySaga);
  yield takeLatest(ENABLE_VENDOR_INTEGRATION.value, enableVendorIntegrationSaga);
  yield takeLatest(DISABLE_VENDOR_INTEGRATION.value, disableVendorIntegrationSaga);
  yield takeLatest(GET_VENDOR_PROPERTIES_IDS.value, getVendorPropertiesIdsSaga);
  yield takeLatest(UPDATE_VENDOR_PROPERTY_IDS.value, updateVendorPropertyIdsSaga);
  yield takeLatest(GET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.value, getLenderReportingActiveForCompanySaga);
  yield takeLatest(SET_LENDER_REPORTING_ACTIVE_FOR_COMPANY.value, setLenderReportingActiveForCompanySaga);
  yield takeLatest(DEALS_BY_COMPANY_ID.value, getDealsByCompanyIdSaga);
  yield takeLatest(DEAL_UPDATE_LENDER_REPORTING.value, updateDealsForLenderReportingSaga);
  yield takeLatest(DELETE_OVERDUE_RGIS_BY_DATE.value, deleteOverdueRgisByDateSaga);
  yield takeLatest(RECOVER_OVERDUE_RGIS_BY_DATE.value, recoverOverdueRgisByDateSaga);
  yield takeLatest(GET_RENTROLL_SETTINGS.value, getRentRollSettingsSaga);
  yield takeLatest(ADD_RENT_CODE_ALIAS.value, addRentCodeAliasSaga);
  yield takeLatest(UPDATE_RENT_CODE_ALIAS.value, updateRentCodeAliasSaga);
  yield takeLatest(DELETE_RENT_CODE_ALIAS.value, deleteRentCodeAliasSaga);
};
